export default `<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 18 18"
  height="18"
  width="18"
>
  <g
    transform="matrix(-1,0,0,1,18,0)"
  >
    <path
      d="M 9,0 A 9,9 0 0 0 0,9 9,9 0 0 0 9,18 9,9 0 0 0 18,9 9,9 0 0 0 17.998,8.949219 h -2 A 7,7 0 0 1 16,9 7,7 0 0 1 9,16 7,7 0 0 1 2,9 7,7 0 0 1 9,2 7,7 0 0 1 13.726562,3.8496094 L 15.345703,2.625 A 9,9 0 0 0 9,0 Z"
    />
    <path
      d="m -0.65540612,11.590557 3.74999962,6.49519 -7.4999996,0 z"
      transform="matrix(-0.80360744,0.79916187,-0.46682451,-0.46942135,22.142361,12.07514)"
    />
  </g>
</svg>`;
